const iOSChrome = () => {
    return navigator.userAgent.indexOf('CriOS') >= 0;
}
export default iOSChrome;